import React, { useState, useEffect } from 'react';
import Classes from '../MainLayout.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import sessionstorage from 'sessionstorage';
import { authActions } from '../../../../redux-store';
import { useSelector } from 'react-redux';
import backend from '../../../../api';
import Logo from '../../LocalComp/Logo/Logo';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import PeopleIcon from '@mui/icons-material/People';

const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" cursor='pointer' height='13px' fill='#192335' viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
)

const DashboardIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" /></svg>
);

const WorkspaceIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" /></svg>
)

const TicketsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" /></svg>
)

const OrdersIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" /></svg>
)

const ClientsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" /></svg>
)

const InvoicesIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" /></svg>
)

const SubIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160z" /></svg>
)

const ServicesIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z" /></svg>
)

const FormsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 64 0 0-64L64 96zm384 0L192 96l0 64 256 0 0-64zM64 224l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64zM64 352l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64z" /></svg>
)

const IntegrationsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2C297 398 352 333.4 352 256l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z" /></svg>
)

const InfoIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" /></svg>
)

const SettingsIcon = (props) => (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" /></svg>
    </>
)

const UpgradesIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" /></svg>
)


export default function Sidebar({
    isMobile,
    setopenMobileSidebar,
}) {
    const navigateTo = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const role = user?.role;
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;
    const userId = user?._id;

    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const handleLogout = async () => {
        localStorage.clear();
        sessionstorage.clear();
        navigateTo('/');
        await dispatch(authActions.logout());
    };

    const handleNavigate = (page) => {
        navigateTo(page);
        if (isMobile) {
            setopenMobileSidebar(false);
        }
    };

    const isAdmin = role === 'admin'; // 🔹 adjust if your role value is different

    return (
        <aside className={Classes.sidebar}>
            <div>
                <div className={Classes.logo}>
                    <Logo alwaysShowText={true} />
                </div>

                <nav className={Classes.navMenu}>
                    {isAdmin ? (
                        <>
                            <h5>MANAGE</h5>
                            <ul>
                                <li
                                    onClick={() => handleNavigate('/content-manager')}
                                    className={activePage === '/content-manager' ? Classes.navActive : ''}
                                >
                                    <div className={Classes.svgIcon}>
                                        <AutoStoriesIcon
                                            height="17px"
                                            fill={activePage === '/content-manager' ? '#FCAA30' : 'black'}
                                        />
                                    </div>
                                    Content Manager
                                </li>
                            </ul>
                            <ul>
                                <li
                                    onClick={() => handleNavigate('/guides')}
                                    className={activePage === '/guides' ? Classes.navActive : ''}
                                >
                                    <div className={Classes.svgIcon}>
                                        <AutoStoriesIcon
                                            height="17px"
                                            fill={activePage === '/guides' ? '#FCAA30' : 'black'}
                                        />
                                    </div>
                                    Guides
                                </li>
                            </ul>

                        </>
                    ) : (
                        <>
                            <h5>ACTIVITY</h5>
                            <ul>
                                <li
                                    onClick={() => handleNavigate('/')}
                                    className={
                                        activePage === '/' || activePage === '/dashboard'
                                            ? Classes.navActive
                                            : ''
                                    }
                                >
                                    <div className={Classes.svgIcon}>
                                        <DashboardIcon
                                            height="17px"
                                            fill={
                                                activePage === '/' || activePage === '/dashboard'
                                                    ? '#FCAA30'
                                                    : 'black'
                                            }
                                        />
                                    </div>
                                    Dashboard
                                </li>
                            </ul>

                            <ul>
                                <li
                                    onClick={() => handleNavigate('/chatbot')}
                                    className={activePage === '/chatbot' ? Classes.navActive : ''}
                                >
                                    <div className={Classes.svgIcon}>
                                        <SmartToyIcon
                                            height="17px"
                                            fill={activePage === '/chatbot' ? '#FCAA30' : 'black'}
                                        />
                                    </div>
                                    Chatbot
                                </li>
                            </ul>

                            <ul>
                                <li
                                    onClick={() => handleNavigate('/guides')}
                                    className={activePage === '/guides' ? Classes.navActive : ''}
                                >
                                    <div className={Classes.svgIcon}>
                                        <AutoStoriesIcon
                                            height="17px"
                                            fill={activePage === '/guides' ? '#FCAA30' : 'black'}
                                        />
                                    </div>
                                    Guides
                                </li>
                            </ul>

                            <ul>
                                <li
                                    onClick={() => handleNavigate('/community-explore')}
                                    className={
                                        activePage === '/community-explore' ? Classes.navActive : ''
                                    }
                                >
                                    <div className={Classes.svgIcon}>
                                        <PeopleIcon
                                            height="17px"
                                            fill={
                                                activePage === '/community-explore'
                                                    ? '#FCAA30'
                                                    : 'black'
                                            }
                                        />
                                    </div>
                                    Community
                                </li>
                            </ul>

                            <ul>
                                <li
                                    onClick={() => handleNavigate('/groups')}
                                    className={activePage === '/groups' ? Classes.navActive : ''}
                                >
                                    <div className={Classes.svgIcon}>
                                        <PeopleIcon
                                            height="17px"
                                            fill={activePage === '/groups' ? '#FCAA30' : 'black'}
                                        />
                                    </div>
                                    Groups
                                </li>
                            </ul>

                            <h5>SETUP</h5>
                            <ul>
                                <li
                                    onClick={() => handleNavigate('/settings/profile')}
                                    className={
                                        activePage === '/settings/profile' ? Classes.navActive : ''
                                    }
                                >
                                    <div className={Classes.svgIcon}>
                                        <SettingsIcon
                                            height="17px"
                                            fill={
                                                activePage === '/settings/profile'
                                                    ? '#FCAA30'
                                                    : 'black'
                                            }
                                        />
                                    </div>
                                    Settings
                                </li>
                            </ul>
                        </>
                    )}
                </nav>
            </div>
        </aside>
    );
}
